<ul class="memberOptions">
  <li class="toggleWrapper">
    <span>Designate as Admin</span>
    <mat-slide-toggle
      labelPosition="before"
      [disabled]="isCurrentUser()"
      [checked]="member().userRole === 2"
      (change)="toggleMemberRole()"
      ></mat-slide-toggle>
  </li>
  @if(groups().length > 0){
    <li class="toggleWrapper">
      <span>Full Access</span>
      <mat-slide-toggle
        labelPosition="before"
        [checked]="hasFullAccess()"
        [disabled]="member().userRole === 2"
        (change)="toggleFullAccess()"
        ></mat-slide-toggle>
    </li>
  }
  @if(loaded()){
    @if(error()){
      <li>
        <div class="error-message">{{error()}}</div>
      </li>
    }
    @else if(!hasFullAccess() && groups().length > 0){
      <li>
        <app-member-assignment-to-standards
          [groups]="memberGroups()"
          [fullAccess]="hasFullAccess()"
          (groupsChange)="onGroupsChange($event)"
          ></app-member-assignment-to-standards>
      </li>
    }
  }

  <li>
    <a class="removeMember" (click)="removeMember()">
      <mat-icon fontSet="material-icons-outlined">group_remove</mat-icon>
      <span>Remove from Team</span>
    </a>
  </li>

</ul>
